import { useEffect, useRef, useState } from "react";
import MagnifyingGlassIcon from "../Icon/MagnifyingGlassIcon.jsx";
import Modal from "../../../../Common/js/components/Modal/Modal.jsx";
import Button from "../Button/Button.jsx";

import { string } from "prop-types";

const propTypes = {
  endpoint: string,
  placeholder: string,
  initialQuery: string,
};

const defaultProps = {
  endpoint: "",
};

const QuickSearchBar = (props) => {
  const { endpoint, placeholder, initialQuery } = props;

  const [isOpen, setOpen] = useState(false);
  const [query, setQuery] = useState(initialQuery || ""); // proptypes will let null through

  const inputRef = useRef();

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSubmit = (e, query) => {
    e.preventDefault();
    window.location.assign(endpoint + "?q=" + query);
  };

  return (
    <div className="quick-search-bar">
      <button
        type="button"
        className="quick-search-bar__open"
        onClick={() => setOpen(true)}
        aria-label="Quick search"
      >
        <MagnifyingGlassIcon width="24" height="24" />
      </button>

      <Modal
        isOpen={isOpen}
        onClose={() => setOpen(false)}
        className="modal--quick-search-bar"
      >
        <div className="quick-search-bar__modal">
          <div className="quick-search-bar__search-form">
            <form
              className={"search-form"}
              onSubmit={(e) => {
                handleSubmit(e, query);
              }}
            >
              <input
                type="text"
                className="search-form__input"
                placeholder={placeholder}
                ref={inputRef}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />{" "}
              {query === "" ? (
                <MagnifyingGlassIcon
                  className="search-form__icon"
                  width="24"
                  height="24"
                />
              ) : (
                <Button
                  type="submit"
                  className="search-form__submit btn"
                  aria-label="Search"
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="feather feather-arrow-right"
                    >
                      <line x1="5" y1="12" x2="19" y2="12"></line>
                      <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                  }
                >
                  Go
                </Button>
              )}
            </form>
          </div>
        </div>
      </Modal>
    </div>
  );
};

QuickSearchBar.propTypes = propTypes;
QuickSearchBar.defaultProps = defaultProps;
export default QuickSearchBar;
